module.exports = __webpack_public_path__ + "img/show-modal-btn.85b26dcc.png";